import PropTypes from "prop-types";

import T from "../translations/Translations";

import "../../styles/AddressBlock.scss";
import "../../styles/global/Global.scss";

/**
 * @name StudentAddressBlock
 * @param {*} param0
 * @returns a Grey background block with user email and address
 * !!!!!! This is the STUDENTS address block only. Top right of screen. !!!!!!
 */
const StudentAddressBlock = ({ studentIcData }) => {
    const studentTitle = T({ key: "OE_Student_Info_Student_Title" });
    const addressLabel = T({ key: "OE_Student_Info_Address" });
    const unavailable = T({ key: "OE_Unavailable" });

    return (
        <div className="addressBlock-background">
            <div className="address-block-label">{studentTitle}:</div>
            <hr />
            <div className="email-container">
                <div className="email-label">{addressLabel}:</div>
                {studentIcData ? (
                    <div className="email">{`${studentIcData?.address?.addressLine1} ${studentIcData?.address?.city} ${studentIcData?.address?.state} ${studentIcData?.address?.zip}`}</div>
                ) : (
                    <div className="email">
                        {studentIcData?.address?.addressLine1
                            ? `${studentIcData?.address?.addressLine1} ${studentIcData?.address?.city} ${studentIcData?.address?.state} ${studentIcData?.address?.zip}`
                            : unavailable}
                    </div>
                )}
            </div>
        </div>
    );
};

StudentAddressBlock.propTypes = {
    studentIcData: PropTypes.oneOfType([PropTypes.object])
};

StudentAddressBlock.defaultProps = {
    studentIcData: null
};

export default StudentAddressBlock;
